import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Stroller photo load

export const STROLLER_PRODUCT_GALLERY_FETCH_TRIGGER = "STROLLER_PRODUCT_GALLERY_FETCH_TRIGGER";
export interface StrollerProductGalleryFetchTriggerAction {
    readonly type: typeof STROLLER_PRODUCT_GALLERY_FETCH_TRIGGER;
    readonly strollerSlug: string;
    readonly strollerVariantId: number | null;
}
export const STROLLER_PRODUCT_GALLERY_FETCH_REQUEST = "STROLLER_PRODUCT_GALLERY_FETCH_REQUEST";
export interface StrollerProductGalleryFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLER_PRODUCT_GALLERY_FETCH_REQUEST;
    readonly strollerSlug: string;
    readonly strollerVariantId: number | null;
}
export interface StrollerProductGalleryFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        stroller: number;
        strollerPhotos: number[];
        strollerVariants: number[];
    };
}
export const STROLLER_PRODUCT_GALLERY_FETCH_SUCCESS = "STROLLER_PRODUCT_GALLERY_FETCH_SUCCESS";
export interface StrollerProductGalleryFetchSuccessAction extends APISuccessAction<StrollerProductGalleryFetchNormalizedResponse> {
    readonly type: typeof STROLLER_PRODUCT_GALLERY_FETCH_SUCCESS;
    readonly strollerSlug: string;
    readonly strollerVariantId: number | null;
}
export const STROLLER_PRODUCT_GALLERY_FETCH_FAILURE = "STROLLER_PRODUCT_GALLERY_FETCH_FAILURE";
export interface StrollerProductGalleryFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLER_PRODUCT_GALLERY_FETCH_FAILURE;
    readonly strollerSlug: string;
    readonly strollerVariantId: number | null;
}

export const strollerProductGalleryFetchTrigger = (
    strollerSlug: string,
    strollerVariantId: number | null,
): StrollerProductGalleryFetchTriggerAction => ({
    type: STROLLER_PRODUCT_GALLERY_FETCH_TRIGGER,
    strollerSlug,
    strollerVariantId,
});
export const strollerProductGalleryFetchApi = {
    request: (
        strollerSlug: string,
        strollerVariantId: number | null,
    ): StrollerProductGalleryFetchRequestAction => ({
        type: STROLLER_PRODUCT_GALLERY_FETCH_REQUEST,
        strollerSlug,
        strollerVariantId,
    }),
    success: (
        strollerSlug: string,
        strollerVariantId: number | null,
        response: StrollerProductGalleryFetchNormalizedResponse,
    ): StrollerProductGalleryFetchSuccessAction => ({
        type: STROLLER_PRODUCT_GALLERY_FETCH_SUCCESS,
        strollerSlug,
        response,
        strollerVariantId,
    }),
    failure: (
        strollerSlug: string,
        strollerVariantId: number | null,
        error: string,
    ): StrollerProductGalleryFetchFailureAction => ({
        type: STROLLER_PRODUCT_GALLERY_FETCH_FAILURE,
        strollerSlug,
        error,
        strollerVariantId,
    }),
};
